<template>
	<div
		class="flex space-x-4 rounded border-2 p-2"
		@click="!disabled && $emit('click', value)"
		:class="{ 'pointer-events-none opacity-80': disabled, 'border-connectProBlue cursor-pointer': !disabled }"
	>
		<div class="flex items-center">
			<div class="rounded-full border-2 border-gray-700 h-4 w-4 flex items-center justify-center" :class="{ 'bg-connectProBlue': isActive }">
				<div v-if="isActive" class="white-circle"></div>
			</div>
		</div>
		<div class="w-full">
			<slot :name="`input_${label}`" v-if="isActive">
				<div v-html="label"></div>
			</slot>
			<div v-html="label" v-else></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BaseRadio',
	props: {
		label: { required: true, type: String },
		disabled: {},
		value: { required: true },
		formValue: { required: true },
	},
	computed: {
		isActive() {
			return this.value === this.formValue;
		},
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
};
</script>

<style scoped>
.white-circle {
	@apply rounded-full bg-white;
	height: 6px;
	width: 6px;
}
</style>
